import React, { createContext, useEffect } from 'react';

import { useShow } from '../hooks';

export const PersonContext = createContext(null);

export function PersonProvider({ id, children }) {
  const { handleShow, entity: person, loading } = useShow('people');

  useEffect(() => {
    handleShow(id);
  }, [ id, handleShow ]);

  if (loading) {
    console.log('Loading person', id);
    return <div>Loading person {id}... </div>;
  }

  console.log('Rendering PersonProvider', id, person);

  return (
    <PersonContext.Provider value={{ person }}>
      {children}
    </PersonContext.Provider>
  );
}